import { createColumn, getSortOptions } from "@repo/mfe-core";
import type { IntlShape } from "react-intl";

export const tableColumns = [
  createColumn("identityDisplayName", "Identity", "18rem", {
    isPinned: true,
    hasCheckbox: false,
  }),
  createColumn("policyName", "Policy Name", "15rem"),
  createColumn("severity", "Severity", "10rem"),
  createColumn("status", "Status", "10rem"),
  createColumn("ttr", "TTR", "10rem"),
  createColumn("remediation", "Remediation", "15rem", { isSortable: false }),
  createColumn("tags", "Tags", "12rem"),
  createColumn("actionColumn", "actionColumn", "min-content", {
    isPinned: true,
    isColumnConfigEnabled: true,
  }),
];

const sortableColumns = [
  "identityDisplayName",
  "policyName",
  "severity",
  "status",
  "ttr",
  "remediation",
  "tags",
];

export const getSortConfigs = (intl: IntlShape) =>
  sortableColumns.map((key) => ({ key, sortOptions: getSortOptions(intl) }));
